module.exports = __webpack_public_path__ + "static/media/dark-motion-constellation-generation.d2b247f.mp4";